module.exports = __webpack_public_path__ + "static/media/gusset-box.43b26aa8.gif";